import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TickerMarquee = () => {
  const [items, setItems] = useState([
    'EL OPEN AIR',
    'BRUXELLES',
    'TICKETS DISPONIBLES',
    'LA FAMILIA',
    'MIRANO CONTINENTAL',
    'NOS VEMOS',
  ]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/ticker`);
        if (response.data.messages && response.data.messages.length > 0) {
          setItems(response.data.messages);
        }
      } catch (error) {
        // Keep default messages if fetch fails
      }
    };
    fetchMessages();
  }, []);

  // Double the items for seamless loop
  const doubledItems = [...items, ...items];

  return (
    <div 
      className="w-full border-y border-white/10 bg-black/60 py-3 overflow-hidden"
      data-testid="ticker-marquee"
    >
      <div className="animate-marquee whitespace-nowrap flex">
        {doubledItems.map((item, index) => (
          <span 
            key={index} 
            className="inline-flex items-center mx-6"
          >
            <span className="text-xs tracking-[0.22em] uppercase text-[#B9B2A8]">
              {item}
            </span>
            <span className="ml-6 text-[#C9A84C]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default TickerMarquee;
